import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Page from 'flarum/common/components/Page';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import ReplyComposer from 'flarum/forum/components/ReplyComposer';
import { openDiscussion, openReply, readLink, cleanAddress } from './quickCompose';

app.initializers.add('happydigital-quick-compose', () => {
  // "?compose=1…" opens the new discussion box on whichever page the link lands on.
  extend(Page.prototype, 'oncreate', function () {
    const link = readLink();
    // Deferred: opening a modal or the composer while the page is being drawn trips
    // Mithril's "nested m.redraw.sync()" error.
    if (link && link.kind === 'discussion') setTimeout(() => openDiscussion(link), 0);
  });

  // "?reply=1…" needs the discussion, which is loaded after the page is created.
  extend(DiscussionPage.prototype, 'show', function (this: DiscussionPage, _result: unknown, discussion: any) {
    const link = readLink();
    if (link && link.kind === 'reply') setTimeout(() => openReply(link, discussion), 0);
  });

  // A reply link away from a discussion page has nothing to reply to.
  extend(Page.prototype, 'oncreate', function (this: any) {
    const link = readLink();
    if (link && link.kind === 'reply' && !(this instanceof DiscussionPage)) cleanAddress();
  });

  // What was sent from a link-opened box carries the link's source (RecordSentFromLink).
  // Core clears composer fields when the box closes, so the source never leaks into a later post.
  extend(DiscussionComposer.prototype, 'data', function (this: any, data: Record<string, unknown>) {
    const ref = this.composer.fields.quickComposeRef;
    if (ref) data.quickComposeRef = ref;
  });

  extend(ReplyComposer.prototype, 'data', function (this: any, data: Record<string, unknown>) {
    const ref = this.composer.fields.quickComposeReplyRef;
    if (ref) data.quickComposeReplyRef = ref;
  });
});
